<app-admin-topbar></app-admin-topbar>
<app-admin-sidebar></app-admin-sidebar>

<main>
  <router-outlet></router-outlet>
  <ls-back-to-top class="d-none d-md-block"></ls-back-to-top>
</main>

<app-footer></app-footer>

